export default class B68Helper {
    constructor(app, mainelement) {
        this.app = app;
        this.oldValue = null
        this.mainElement = mainelement
        let currentValue = mainelement["distancia_soportes"].value
        this.oldValue = currentValue ? currentValue.id : null
    }

    getConfiguration(){
        if( !this.app.currentConfiguration && !this.configuration ) return null;

        if( this.configuration ) return this.configuration;

        return this.app.currentConfiguration
    }
    /**
     * Estem en gama 68
     * @returns bool
     */
    is68() {
        let configuration = this.getConfiguration()
        if( !configuration ) return false;
        if( configuration.familyParameters.length == 0 ) return false;
        if( !configuration.familyParameters["gama"] ) return false;

        let idgama = configuration.familyParameters["gama"].value.id;

        if (idgama == '68') return true;

        return false
    }

    isDistanceOk(mainElementIndex){
        if( this.isNoMetadata() ) return false;

        if( false
            && this.app.currentConfiguration.mainElementParameters[mainElementIndex]
            ){
            // Si ha canviat el valor de distancia_soportes mostrar toast
            let currentValue = this.app.currentConfiguration.mainElementParameters[mainElementIndex]["distancia_soportes"].value
            if(
                (this.oldValue == null && currentValue) || // No hi havia valor i ara si
                (this.oldValue && currentValue && currentValue.id && this.oldValue != currentValue.id) // Hi havia valor i ha canviat
                ){
                this.showInfoMessage(mainElementIndex)
                let message = this.app.translate("s3_min_distance_alert") +
                    "<span class='font-weight-bold'>" +
                    this.getMetadata(mainElementIndex).
                        distance_supports_proposed +
                    "</span>"
                    this.app.showToast(
                        message
                    )
                this.oldValue = null
            }
        }

        this.firstCalculation = false

        // Get metadata for item with index mainElementIndex
        let metadata = this.getMetadata(mainElementIndex);

        if (metadata == null) return false;
        if (metadata.distance_supports_status == null) return false;

        if (metadata.distance_supports_status == "OK"){
            // Si la distancia no tiene valor, poner la propuesta
            // let mainElement = this.getConfiguration().mainElementParameters[mainElementIndex]
            // if( mainElementParameters[mainElementIndex]['distancia_soportes'] == null ||
            //     mainElementParameters[mainElementIndex]['distancia_soportes'].value.id == "N/A"){
            //     this.app.currentConfiguration.items[mainElementIndex].distance = metadata.distance_supports_proposed
            // }

            return true;
        }

        return false
    }
    isNoMetadata() {
        if( !this.getConfiguration() ) return true;
        if (this.getConfiguration().metadata == null) {
            return true;
        }
        if (this.getConfiguration().metadata.perfil_options == null) {
            return true;
        }
        return false;
    }

    /**
     * Get metadata for item with index mainElementIndex
     * @param mainElementIndex
     * @returns {*}
     */
    getMetadata(mainElementIndex) {
        if (this.isNoMetadata()) return null;

        return this.getConfiguration().metadata.perfil_options[mainElementIndex];
    }

    isNoDistanceAvailable(mainElementIndex) {
        let metadata = this.getMetadata(mainElementIndex);

        if (metadata == null) return false;
        if (metadata.distance_supports_status == null) return false;

        if (metadata.distance_supports_status == "FAIL-NOCALC") return true;

        return false;
    }
    getMessage(mainElementIndex) {
        let metadata = this.getMetadata(mainElementIndex);

        if (metadata == null) return "";

        return metadata.message;
    }
    async beforeUpdateParameter(mainElement, param, value) {
        if (param == "dimensiones" || param == "altura_trabajo"  || param == "altura_trabajo_rack") {
            // save old value, i despres mostrar toast amb missatge si ha canviat
            if( mainElement["distancia_soportes"].value )
                this.oldValue = mainElement["distancia_soportes"].value.id
            else{
                this.oldValue = null
            }
            mainElement["distancia_soportes"].value = '';
        }
    }
    async afterUpdateParameter(mainElement, param, value) {

    }
    showInfoMessage(mainElementIndex) {
        Unex.log("Displaying info about distancia_soportes (is ok: " + this.isDistanceOk() + ")", "Configurator")
        Unex.log(this.getMessage(mainElementIndex))
        this.app.showToast(
            this.getMessage(mainElementIndex)
        )
    }
}

